const { default: axios } = require('axios');

const getAccessToken = () => localStorage.getItem('accessToken');
const deleteAccessToken = () => localStorage.removeItem('accessToken');

const invokeGet = async (url) => {
    return await axios
        .get(url, {
            headers: {
                Authorization: `Bearer ${getAccessToken()}`,
                'Content-Type': 'application/json',
            },
        })
        .then((res) => {
            return res;
        })
        .catch((err) => {
            const message = err.response.data.message
            if (message.startsWith("jwt")) {
                deleteAccessToken();
                window.location.href = '/authentication/login';
            }


            if (err.response.status === 401) {
                return {
                    data: {
                        message: 'Unauthorized',
                    },
                };
            }

            return err.response;
        });
};

const invokePost = async (url, body) => {
    return await axios
        .post(url, JSON.stringify(body), {
            headers: {
                Authorization: `Bearer ${getAccessToken()}`,
                'Content-Type': 'application/json',
            },
        })
        .then((res) => {
            console.log('res: ', res);
            return res;
        })
        .catch((err) => {
            const message = err.response.data.message
            if (message.startsWith("jwt")) {
                deleteAccessToken();
                window.location.href = '/authentication/login';
            }

            if (err.response.status === 401) {
                return {
                    data: {
                        message: 'Unauthorized',
                    },
                };
            }

            return err.response;
        });
};

const invokePatch = async (url, body) => {
    return await axios
        .patch(url, JSON.stringify(body), {
            headers: {
                Authorization: `Bearer ${getAccessToken()}`,
                'Content-Type': 'application/json',
            },
        })
        .then((res) => {
            return res;
        })
        .catch((err) => {
            const message = err.response.data.message
            if (message.startsWith("jwt")) {
                deleteAccessToken();
                window.location.href = '/authentication/login';
            }

            if (err.response.status === 401) {
                return {
                    data: {
                        message: 'Unauthorized',
                    },
                };
            }

            return err.response;
        });
};

const invokeDelete = async (url, body) => {
    return await axios
        .delete(url, {
            headers: {
                Authorization: `Bearer ${getAccessToken()}`,
                'Content-Type': 'application/json',
            },
            data: body,
        })
        .then((res) => {
            return res;
        })
        .catch((err) => {
            const message = err.response.data.message
            if (message.startsWith("jwt")) {
                deleteAccessToken();
                window.location.href = '/authentication/login';
            }

            if (err.response.status === 401) {
                return {
                    data: {
                        message: 'Unauthorized',
                    },
                };
            }

            return err.response;
        });
};

const ApiService = {
    invokeGet,
    invokePost,
    invokePatch,
    invokeDelete,
};

export default ApiService
